/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SequenceAlign } from './SequenceAlign';
import {
    SequenceAlignFromJSON,
    SequenceAlignFromJSONTyped,
    SequenceAlignToJSON,
} from './SequenceAlign';

/**
 * 
 * @export
 * @interface SequencesAlignPayload
 */
export interface SequencesAlignPayload {
    /**
     * 
     * @type {Array<SequenceAlign>}
     * @memberof SequencesAlignPayload
     */
    sequences: Array<SequenceAlign>;
}

/**
 * Check if a given object implements the SequencesAlignPayload interface.
 */
export function instanceOfSequencesAlignPayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sequences" in value;

    return isInstance;
}

export function SequencesAlignPayloadFromJSON(json: any): SequencesAlignPayload {
    return SequencesAlignPayloadFromJSONTyped(json, false);
}

export function SequencesAlignPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequencesAlignPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sequences': ((json['sequences'] as Array<any>).map(SequenceAlignFromJSON)),
    };
}

export function SequencesAlignPayloadToJSON(value?: SequencesAlignPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sequences': ((value.sequences as Array<any>).map(SequenceAlignToJSON)),
    };
}

